import { render, staticRenderFns } from "./NumberKeyboard.vue?vue&type=template&id=50a3f5f8&scoped=true&"
import script from "./NumberKeyboard.vue?vue&type=script&lang=js&"
export * from "./NumberKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./NumberKeyboard.vue?vue&type=style&index=0&id=50a3f5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a3f5f8",
  null
  
)

export default component.exports